import { render, staticRenderFns } from "./XAxisSelectorAntV.vue?vue&type=template&id=ff28c81a&scoped=true"
import script from "./XAxisSelectorAntV.vue?vue&type=script&lang=js"
export * from "./XAxisSelectorAntV.vue?vue&type=script&lang=js"
import style0 from "./XAxisSelectorAntV.vue?vue&type=style&index=0&id=ff28c81a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff28c81a",
  null
  
)

export default component.exports